export default "__VITE_ASSET__B7jQO_Dt__"